export const GENERICO = 1;
export const DIRECTO = 2;
export const PERSONALIZADO = 3;
export const CONJUNTO = 4;
